// Libraries
import _ from 'lodash';

const Json = {
  // Inject JSON functions like 'parse' and 'stringify'.
  parse: JSON.parse,
  stringify: JSON.stringify,

  toForm: (string: string): object => {
    return Json.toObject(string);
  },
  toMutation: (object: object | any[]): string => {
    return Json.toString(object);
  },
  toObject: (string: string): object => {
    return Json.toCamelCaseKeys(Json.parse(string));
  },
  toString: (object: object | any[]): string => {
    return Json.stringify(Json.toSnakeCaseKeys(object));
  },
  mapKeys: (object: object | any[], mapper: (key: string) => any): object | any[] => {
    if (Array.isArray(object)) {
      return _.map(object, (value) => Json.toCamelCaseKeys(value));
    } else if (_.isPlainObject(object)) {
      const reducer = (result: any, value: any, key: string): object => ({
        ...result,
        [mapper(key)]: Json.toCamelCaseKeys(value),
      });
      return _.reduce(object, reducer, {});
    }
    return object;
  },
  mapKeysRecursive: (object: object | any[], mapper: (key: string) => any): object | any[] => {
    if (Array.isArray(object)) {
      return _.map(object, (value) => Json.mapKeysRecursive(value, mapper));
    } else if (_.isPlainObject(object)) {
      const reducer = (result: any, value: any, key: string): object => ({
        ...result,
        [mapper(key)]: Json.mapKeysRecursive(value, mapper),
      });
      return _.reduce(object, reducer, {});
    }
    return object;
  },
  toCamelCaseKeys: (object: object): object => {
    return Json.mapKeys(object, (key) => _.camelCase(key));
  },
  toSnakeCaseKeys: (object: object): object => {
    return Json.mapKeys(object, (key) => _.snakeCase(key));
  },
  toSnakeCaseKeysRecursive: (object: object): object => {
    return Json.mapKeysRecursive(object, (key) => _.snakeCase(key));
  },
  toUpperCaseKeys: (object: object): object => {
    return Json.mapKeys(object, (key) => _.toUpper(key));
  },
};

export default Json;
